module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "dblclick": function($event) {
        _vm.mini = !_vm.mini
      }
    }
  }, [(_vm.showNotification) ? _c('div', {
    staticClass: "notifcation-wrapper"
  }, [_c('div', {
    staticClass: "notification-overlay",
    on: {
      "click": function($event) {
        _vm.showNotification = false
      }
    }
  }), _vm._v(" "), _c('notifcationDrawer', {
    attrs: {
      "leftPos": _vm.mini ? 100 : 300
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "sidebar",
    attrs: {
      "permanent": "",
      "app": "",
      "fixed": "",
      "dark": "",
      "mini-variant": _vm.mini,
      "mobile-break-point": "",
      "width": _vm.sideBarWidth
    }
  }, [_c('div', [_c('div', {
    staticClass: "sidebar-decoy"
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs-auth-wrapper"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center mb-3"
  }, [_c('router-link', {
    staticClass: "sidebar-logo",
    attrs: {
      "to": {
        name: this.$store.state.auth.user &&
          this.$store.state.auth.user.request_role !== 'listener' ?
          'UploadAlbum' :
          'UserSettings',
      }
    }
  }, [(_vm.mini) ? _c('img', {
    staticClass: "_mini",
    attrs: {
      "src": "/static/images/nav_logo_white_mini.png"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/images/nav_logo_white.png"
    }
  })])], 1), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.stream !== null &&
    _vm.$store.state.streamPlayer == 'active'
  ) ? _c('div', {
    staticClass: "live-notice",
    class: {
      'pl-0': _vm.mini
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'VideoManage'
        })
      }
    }
  }, [(!_vm.mini) ? _c('b', {
    staticClass: "__text"
  }, [_vm._v("View live broadcast")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "icon_wrapper",
    class: {
      dflex: _vm.mini
    }
  }, [_c('v-icon', [_vm._v("circle")]), _vm._v(" "), _c('span', {
    staticClass: "icon_text"
  }, [_vm._v("LIVE")])], 1)]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "logout-modal"
    },
    model: {
      value: (_vm.show_logout_modal),
      callback: function($$v) {
        _vm.show_logout_modal = $$v
      },
      expression: "show_logout_modal"
    }
  }, [_c('logoutModal')], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('div', {
    staticClass: "d-flex gap-10 align-center profile-user"
  }, [_c('div', {
    staticClass: "profile-user__avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentUser.avatar.thumb.url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column gap-4"
  }, [_c('div', {
    staticClass: "profile-user__username"
  }, [_vm._v(_vm._s(_vm.currentUser.username))]), _vm._v(" "), _c('a', {
    staticClass: "profile-user__type",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign Out")])])]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _vm._l((_vm.tabs), function(parent, i) {
    return _c('v-list', {
      key: i,
      staticClass: "py-1 px-0"
    }, [_c('h4', [(parent.name) ? _c('h3', {
      staticClass: "px-3 subheader"
    }, [_vm._v("\n                " + _vm._s(parent.name) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.mini) ? _c('v-list-tile', {
      staticClass: "dflex justify-center align-center"
    }) : _vm._e(), _vm._v(" "), _vm._l((parent.items), function(subMenu, ii) {
      return (
        subMenu.id != 'search' || (subMenu.id === 'search' && _vm.mini)
      ) ? _c('v-list-tile', {
        key: ii,
        staticClass: "side-tab",
        class: [
          _vm.customActiveTab(subMenu) ? 'activeTab' : '',
          {
            'd-none': subMenu.allowedUser &&
              !subMenu.allowedUser.includes(_vm.currentUser.user_type),
          } ],
        attrs: {
          "active-class": subMenu.path ? 'activeTab' : '',
          "to": subMenu.id != 'search' && subMenu.directPath ?
            ("/" + (subMenu.path)) :
            {
              name: subMenu.path
            }
        },
        on: {
          "click": function($event) {
            subMenu.id === 'search' ? _vm.toggleSearch() : null
          }
        }
      }, [_c('v-list-tile-avatar', [(subMenu.id === 'you') ? _c('div', {
        staticClass: "profile-image",
        style: ({
          'background-image': 'url(' + _vm.currentUser.avatar.thumb.url + ')',
        })
      }) : _c('span', [(subMenu.icon.length > 50) ? _c('img', {
        staticClass: "icon _icon_img",
        class: [("icon_" + (subMenu.id))],
        attrs: {
          "src": subMenu.icon
        }
      }) : _c('v-icon', {
        staticClass: "__icon"
      }, [_vm._v("\n                      " + _vm._s(subMenu.icon) + "\n                    ")])], 1)]), _vm._v(" "), (!_vm.mini) ? _c('v-list-tile-title', {
        staticClass: "d-flex justify-space-between align-center"
      }, [(!_vm.mini) ? _c('span', {
        staticClass: "__title"
      }, [_vm._v("\n                    " + _vm._s(subMenu.title) + "\n                  ")]) : (
        subMenu.id === 'notifications' && _vm.badge.message > 0
      ) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'sales' && _vm.badge.sell > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'cart' && _vm.badge.cart > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e()
    })], 2)])
  }) : _vm._l((_vm.tabs), function(parent, i) {
    return _c('v-list', {
      key: i,
      staticClass: "py-1 px-0"
    }, [_c('h4', [(parent.name) ? _c('h3', {
      staticClass: "px-3 subheader"
    }, [_vm._v("\n                " + _vm._s(parent.name) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((parent.items), function(subMenu, ii) {
      return (
        subMenu.id != 'search' || (subMenu.id == 'search' && _vm.mini)
      ) ? _c('v-list-tile', {
        key: ii,
        staticClass: "side-tab",
        class: [
          _vm.customActiveTab(subMenu) ? 'activeTab ${{subMenu}}' : '',
          {
            'd-none': subMenu.allowedUser &&
              _vm.currentUser &&
              !subMenu.allowedUser.includes(_vm.currentUser.user_type),
          } ],
        attrs: {
          "active-class": subMenu.path ? 'activeTab' : '',
          "to": subMenu.directPath ?
            ("/" + (subMenu.path)) :
            {
              name: subMenu.path
            }
        },
        on: {
          "click": function($event) {
            _vm.verifyUser(subMenu)
          }
        }
      }, [_c('v-list-tile-avatar', [(subMenu.id === 'you') ? _c('div', {
        staticClass: "profile-image"
      }) : _c('span', [(subMenu.icon.length > 50) ? _c('img', {
        staticClass: "icon _icon_img",
        class: [("icon_" + (subMenu.id))],
        attrs: {
          "src": subMenu.icon
        }
      }) : _c('v-icon', {
        staticClass: "__icon"
      }, [_vm._v("\n                      " + _vm._s(subMenu.icon) + "\n                    ")])], 1)]), _vm._v(" "), (!_vm.mini) ? _c('v-list-tile-title', {
        staticClass: "d-flex justify-space-between align-center"
      }, [(!_vm.mini) ? _c('span', {
        staticClass: "__title"
      }, [_vm._v("\n                    " + _vm._s(subMenu.title) + "\n                  ")]) : _vm._e(), _vm._v(" "), (subMenu.id === 'notifications' && _vm.badge.message > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'sales' && _vm.badge.sell > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'cart' && _vm.badge.cart > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e()
    }))])
  })], 2)]), _vm._v(" "), _c('div', [(!_vm.mini) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.getters['player/isPlaying']),
      expression: "!$store.getters['player/isPlaying']"
    }],
    staticClass: "mx-2 d-flex flex-column align-center gap-14"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": require('@/assets/app-store-black.svg'),
      "max-height": "59",
      "max-width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.IOS)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": require('@/assets/google-play-black.svg'),
      "max-height": "59",
      "max-width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.ANDROID)
      }
    }
  })]), _vm._v(" "), (!_vm.onMobile) ? _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('side-audio-player', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.getters['navigator/hasAudioPlayer']),
      expression: "$store.getters['navigator/hasAudioPlayer']"
    }],
    ref: "audioPlayer",
    attrs: {
      "isMini": _vm.mini
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mini) ? _c('div', {
    staticClass: "thumbnail-mini-song"
  }, [_c('img', {
    attrs: {
      "src": this.$store.state.player.currentTrackPlaying &&
        this.$store.state.player.currentTrackPlaying.album &&
        this.$store.state.player.currentTrackPlaying.album.cover.url,
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.mini) ? _c('div', {
    staticClass: "side-lang-outer my-5 mx-3"
  }) : _vm._e(), _vm._v(" "), (_vm.mini) ? _c('div', {
    staticClass: "toggle-sidebar _bottom"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    class: {
      inversed: !_vm.mini
    },
    attrs: {
      "src": "/static/images/slide-right.svg"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('QrCode', {
    ref: "qrCode"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74e901d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/index.vue
// module id = 1781
// module chunks = 180